import React from 'react';

const ArtificialIntelligence = () => {
  return (
    <div>
      ArtificialIntelligence
      ArtificialIntelligence
    </div>
  );
}

export default ArtificialIntelligence;
